<template>
    <td-dialog v-dialogDrag :title="title" :before-close="configDialogClose" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules">
            <el-form-item :label="$t('common.SERVICE_NAME')" :label-width="formLabelWidth" prop="serviceName" v-show="nameShow">
                <td-input v-model="serviceName" :maxlength="500"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.FILE_SERVER')" :label-width="formLabelWidth" prop="fileServerId">
                <td-select v-model="formInfo.fileServerId" :clearable="false" keys="sId" text="sName" :options="fileserverList" :placeholder="$t('common.PLEASE_SELECT')"></td-select>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="btnSave('formInfo')" :loading="loading">{{ $t('common.SAVE') }} </td-button>
            <td-button @click="configDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'editItems'],
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.initData();
        if (this.editItem != null) {
            this.serviceName = this.editItem.serviceName;
        }
    },
    // 定义变量
    data() {
        return {
            formInfo: {
                fileServerId: ''
            },
            serviceName: '',
            fileserverList: [],
            nameShow: true,
            formLabelWidth: '40%',
            rules: {
                fileServerId: [{ required: true, message: this.$t('error.ERROR_IS_NOT_NULL'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        initData() {
            if (this.editItems != null && this.editItems.length > 0) {
                this.nameShow = false;
            }
            this.fileserverList = [];
            Api.getFileServerList('{}', response => {
                this.fileserverList = response.data.content;
                if (this.editItem != null) {
                    this.formInfo.fileServerId = this.editItem.fileServerId;
                }
            });
        },
        //保存信息
        btnSave(formInfo) {
            this.$refs[formInfo].validate(valid => {
                if (valid) {
                    let param = [];
                    if (this.editItems != null && this.editItems.length > 0) {
                        for (let i = 0; i < this.editItems.length; i++) {
                            let editInfo = this.editItems[i];
                            editInfo.fileServerId = this.formInfo.fileServerId;
                            editInfo.updateUser = sessionStorage.getItem('userId');
                            param.push(editInfo);
                        }
                    } else if (this.editItem != null) {
                        if (this.serviceName != null) {
                            this.editItem.serviceName = this.serviceName;
                        }
                        this.editItem.fileServerId = this.formInfo.fileServerId;
                        this.editItem.updateUser = sessionStorage.getItem('userId');
                        param.push(this.editItem);
                    }
                    Api.editConfigInfo(JSON.stringify(param), response => {
                        if (null === response || null === response.data) {
                            return;
                        }
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            return;
                        }
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                        this.$emit('submit');
                        this.configDialogClose();
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        configDialogClose() {
            this.$emit('configDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
